/**
 * @typedef {('potplanten'|'substraatteelt')} TModelVersion
 */
export const modelVersions = {
    potplant: 'potplanten',
    substraat: 'substraatteelt',
};

export const modelVersionKeys = {
    potplanten: 'potplant',
    substraatteelt: 'substrate',
};

export const guestKey = 'GUEST';

// export const modelBaseUrl_LOCAL = '/api/';
// export const modelBaseUrl_PROD = 'https://fertilizeradvice.wur.nl/api/';
// // old: 'https://www.digigreenhouse.wur.nl/bemestingsmodel3/Default.aspx';

// let [environment] = window.location.hostname.split('.');
// environment = environment.toLowerCase();
// console.log('environment:', environment);
// const localDevelopment = environment === 'localhost';
// export const modelBaseUrl = localDevelopment
//     ? modelBaseUrl_LOCAL
//     : modelBaseUrl_PROD;

export const modelBaseUrl = '/api/';
/**
 * @typedef {('vd'|'gt')} TDrainType
 */
export const drainReuseKeys = {
    free: 'vd',
    reuse: 'gt',
};

// export const substrateKeys = {
//     steenwol: 'vs',
//     urethaan: 'vs',
//     fenolhars: 'vs',
//     veen: 'vs',
//     veensubstraat: 'vs',
//     kokos: 'kk',
// };
